import React from 'react'
import PropTypes from 'prop-types'
import './TextEditorHeaderButton.scss'
import { getMergedClassNames } from '../../../../utils/HTMLutils'
const rootClassName = 'text-editor-header-button'

export default function TextEditorHeaderButton(props) {
  return (
    <button
      className={getMergedClassNames([
        rootClassName,
        props.active ? 'active' : ''
      ])}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.icon}
    </button>
  )
}

TextEditorHeaderButton.propTypes = {
  icon: PropTypes.object,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  disabled: PropTypes.bool
}
